import clsx from "clsx"
import React from "react"

import styles from "./Navbar.module.css"

export type NavbarProps = {
  className?: string
  gutterBottom?: boolean
  slotEnd?: React.ReactNode
  navBarTitle?: string
}

const Navbar = ({ gutterBottom = true, className, slotEnd }: NavbarProps) => {
  return (
    <div
      className={clsx("w-full", {
        ["mb-4 md:mb-8"]: gutterBottom,
      })}
    >
      <nav
        className={clsx(
          "relative h-[62px] border-b border-b-onSurface-200 bg-onSurface-50",
          className,
          styles.root,
          "flex items-center py-1"
        )}
      >
        <div
          className={clsx(
            "flex w-full flex-wrap items-center justify-between p-2 sm:px-5 md:flex-nowrap",
            styles.container
          )}
        >
          <div className="flex grow items-center justify-start md:block md:grow-0">
            <img
              src="https://assets.suraasa.com/logos/v2/mini.webp"
              alt="suraasa logo"
              height={35}
              width={35}
              className="block md:hidden"
            />
            <img
              src="https://assets.suraasa.com/logos/v2/full-dark.webp"
              alt="suraasa logo"
              width={120}
              className="hidden md:block"
            />
          </div>
          {slotEnd}
        </div>
      </nav>
    </div>
  )
}

export default Navbar
